import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import BaseLayout from './base-layout';

const Layout: React.FC = ({ children }) => {
  return (
    <>
      <CssBaseline />
      <BaseLayout> {children} </BaseLayout>
    </>
  );
};

export default Layout;
